import React from 'react';
import { graphql } from 'gatsby';

import PropTypes from 'prop-types';
import Layout from '../components/layout';
import SEO from '../components/seo';
import Header from '../components/header';
import Reviews from '../templates/reviews';

const ReviewsPage = ({
  data: {
    allContentfulReview: { edges: reviews },
    allContentfulContacts: { edges: rawContacts },
    site: {
      siteMetadata: {
        geo, address, title, siteUrl, image,
      },
    },
  },
  location,
}) => {
  const contacts = {};
  // eslint-disable-next-line no-return-assign
  rawContacts.forEach(({ node: { type, value } }) => (contacts[type] = value));
  return (
    <Layout>
      <SEO
        lang="ru"
        title="Отзывы"
        keywords={[
          'reviews',
          'отзывы',
          'контакты',
          'отель',
          'гостевой',
          'дом',
          'hotel',
          'guest',
          'house',
          'dom',
          'yalta',
          'гостевой дом',
          'guest house',
          'dom_yalta',
          'аренда жилья в ялте 2019',
          'отдых в ялте 2019',
          'семейный отдых',
        ]}
        jsonld={Reviews.JSONLD({
          items: reviews,
          geo,
          address,
          title,
          siteUrl,
          image,
          telephone: contacts.phone,
        })}
      />
      <Header contacts={contacts} location={location} sticky />
      <main className="main">
        <div className="pagecontent">
          <div className="container">
            <Reviews items={reviews} />
          </div>
        </div>
      </main>
    </Layout>
  );
};

export const query = graphql`
  query {
    site {
      siteMetadata {
        title
        description
        author
        siteUrl
        image
        geo {
          latitude
          longitude
        }
        address {
          streetAddress
          addressLocality
          addressRegion
          postalCode
          addressCountry
        }
      }
    }
    allContentfulContacts {
      edges {
        node {
          id
          type
          value
        }
      }
    }
    allContentfulReview(sort: { fields: [created], order: DESC }) {
      edges {
        node {
          id
          name
          email
          created
          comment {
            json
          }
        }
      }
    }
  }
`;

ReviewsPage.propTypes = {
  data: PropTypes.shape({
    allContentfulReview: PropTypes.shape({
      edges: PropTypes.array,
    }).isRequired,
    allContentfulContacts: PropTypes.shape({
      edges: PropTypes.array,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape().isRequired,
};

export default ReviewsPage;
